import { SliderPanel } from "veronica-ui-component/dist/component/core";
import { ExchangeRateRefDateMappingFormPanel } from "./ExchangeRateRefDateMappingFormPanel";
import ExchangeRateRefDateMappingMaintenance from "./ExchangeRateRefDateMappingMaintenance";
import { useExchangeRateRefDateMappingTracked } from "presentation/store/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingProvider";
export const ExchangeRateRefDateMappingMasterView: React.FC = () => { 
    const [exchangeState] = useExchangeRateRefDateMappingTracked();
    const { isShowEditPanel } = exchangeState;
    return <> 
        <div className="main-comp-wrapper im-hide-side-form-draggable"> 
            <ExchangeRateRefDateMappingMaintenance/> 
            { 
                (isShowEditPanel &&  
                <SliderPanel 
                    isOpen={false} 
                    leftSectionWidth={"100%"} 
                    rightSectionWidth={"0%"} 
                    leftChildren={<ExchangeRateRefDateMappingFormPanel/>} 
                /> 
                ) 
            } 
        </div> 
    </> 
} 
